// Rotas da interface do usuário
export const APP_ROUTES = {
  // Rotas principais
  ROOT: "/",
  REGISTER: "/register",
  REGISTRATION_STATUS: "/registration_status",
  ADMIN: "/admin",
  
  // Autenticação
  SIGN_IN: "/users/sign_in",
  SIGN_UP: "/users/sign_up",
  REQUEST_PASSWORD_RESET: "/users/password/new",
  RESET_PASSWORD: "/users/password/edit",
  AUTH_SIGN_IN: "/admin/users/sign_in",
  AUTH_SIGN_OUT: "/admin/users/sign_out",
  AUTH_PASSWORD_RESET: "/admin/users/password",
  
  // Páginas principais
  EVENTS: "/events",
  EVENT: "/event",
  CONTACT_US: "/contact_us",
  OPPORTUNITIES: "/opportunities",
  BLOOD_DONATIONS: "/blood_donations",
  
  // ONGs e Ações
  NGOS: "/ngos",
  NGO: "/ngo",
  GALLERY_NGO: "/gallery_ngo",
  ACTION_MANAGEMENTS: "/action_managements",
  ACTION_MANAGEMENT: "/action_management",
  GALLERY_ACTION: "/gallery_action",
  MOVING_ACTIONS: "/moving_actions",
  
  // Causas
  CAUSES: "/causes",
  FIND_YOUR_CAUSE: "/find_your_cause",
  CAUSE_NGOS: (id) => `/causes/${id}/ngos`,
  
  // Informações e Recursos
  KNOWLEDGE_TRAILS: "/knowledge_trails",
  ACTIVE_NOTICES: "/active_notices",
  INCOME_TAX: "/income_tax",
  ORGAN_DONOR: "/organ_donor",
  PARTNERS: "/partners",
  SPONSORS: "/sponsors",
  SPONSORS_COMPANIES: "/sponsors_companies",
  FOOD_BANK: "/food_bank",
  PRIVACY_POLICY: "/politica"
};
